import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';
import scrollBehavior from './router.scrollBehavior.js';

var _f0009660 = function _f0009660() {
  return interopDefault(import('../pages/monitoring.vue'
  /* webpackChunkName: "pages/monitoring" */
  ));
};

var _09963114 = function _09963114() {
  return interopDefault(import('../pages/redirect_url.vue'
  /* webpackChunkName: "pages/redirect_url" */
  ));
};

var _5a792afc = function _5a792afc() {
  return interopDefault(import('../pages/tools/grid.vue'
  /* webpackChunkName: "pages/tools/grid" */
  ));
};

var _6ff3ef24 = function _6ff3ef24() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "pages/_market/_language/index" */
  ));
};

var _2bc1b851 = function _2bc1b851() {
  return interopDefault(import('../pages/_market/_language/autolog.vue'
  /* webpackChunkName: "pages/_market/_language/autolog" */
  ));
};

var _4222e734 = function _4222e734() {
  return interopDefault(import('../pages/_market/_language/cart.vue'
  /* webpackChunkName: "pages/_market/_language/cart" */
  ));
};

var _5762d4d0 = function _5762d4d0() {
  return interopDefault(import('../pages/_market/_language/help/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/index" */
  ));
};

var _dca4a8f6 = function _dca4a8f6() {
  return interopDefault(import('../pages/_market/_language/login.vue'
  /* webpackChunkName: "pages/_market/_language/login" */
  ));
};

var _b07d3c80 = function _b07d3c80() {
  return interopDefault(import('../pages/_market/_language/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/lost-password" */
  ));
};

var _1ee5a5ed = function _1ee5a5ed() {
  return interopDefault(import('../pages/_market/_language/reset-password.vue'
  /* webpackChunkName: "pages/_market/_language/reset-password" */
  ));
};

var _1f3c9ba8 = function _1f3c9ba8() {
  return interopDefault(import('../pages/_market/_language/signup.vue'
  /* webpackChunkName: "pages/_market/_language/signup" */
  ));
};

var _30f6d0d8 = function _30f6d0d8() {
  return interopDefault(import('../pages/_market/_language/sitemap/index.vue'
  /* webpackChunkName: "pages/_market/_language/sitemap/index" */
  ));
};

var _3cdf9d6e = function _3cdf9d6e() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "pages/_market/_language/store-locator/index" */
  ));
};

var _4baa0da2 = function _4baa0da2() {
  return interopDefault(import('../pages/_market/_language/user/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/index" */
  ));
};

var _0330cdf4 = function _0330cdf4() {
  return interopDefault(import('../pages/_market/_language/help/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/confirm" */
  ));
};

var _43d9531c = function _43d9531c() {
  return interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
  ));
};

var _51492e83 = function _51492e83() {
  return interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
  /* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
  ));
};

var _b647cce0 = function _b647cce0() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "pages/_market/_language/s/home-by-me" */
  ));
};

var _ee1edf88 = function _ee1edf88() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "pages/_market/_language/s/lighting" */
  ));
};

var _7a8d8aeb = function _7a8d8aeb() {
  return interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
  /* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
  ));
};

var _1288a9c0 = function _1288a9c0() {
  return interopDefault(import('../pages/_market/_language/t/confirmed.vue'
  /* webpackChunkName: "pages/_market/_language/t/confirmed" */
  ));
};

var _8fae02ac = function _8fae02ac() {
  return interopDefault(import('../pages/_market/_language/t/login.vue'
  /* webpackChunkName: "pages/_market/_language/t/login" */
  ));
};

var _7dc48036 = function _7dc48036() {
  return interopDefault(import('../pages/_market/_language/t/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/t/lost-password" */
  ));
};

var _32adf6f2 = function _32adf6f2() {
  return interopDefault(import('../pages/_market/_language/t/payment.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment" */
  ));
};

var _fc692426 = function _fc692426() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-canceled.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-canceled" */
  ));
};

var _177815f3 = function _177815f3() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
  ));
};

var _1830ff5e = function _1830ff5e() {
  return interopDefault(import('../pages/_market/_language/t/refused.vue'
  /* webpackChunkName: "pages/_market/_language/t/refused" */
  ));
};

var _12125906 = function _12125906() {
  return interopDefault(import('../pages/_market/_language/t/shipping.vue'
  /* webpackChunkName: "pages/_market/_language/t/shipping" */
  ));
};

var _cd5e78b2 = function _cd5e78b2() {
  return interopDefault(import('../pages/_market/_language/t/signup.vue'
  /* webpackChunkName: "pages/_market/_language/t/signup" */
  ));
};

var _157c6728 = function _157c6728() {
  return interopDefault(import('../pages/_market/_language/user/gift-card-download.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-card-download" */
  ));
};

var _0fb817e6 = function _0fb817e6() {
  return interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-cards" */
  ));
};

var _41803588 = function _41803588() {
  return interopDefault(import('../pages/_market/_language/user/orders/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/index" */
  ));
};

var _02d53cf9 = function _02d53cf9() {
  return interopDefault(import('../pages/_market/_language/user/profile.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile" */
  ));
};

var _4cb464bc = function _4cb464bc() {
  return interopDefault(import('../pages/_market/_language/user/profile/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/index" */
  ));
};

var _4a66568c = function _4a66568c() {
  return interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
  ));
};

var _d9238cc6 = function _d9238cc6() {
  return interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
  ));
};

var _459a6c21 = function _459a6c21() {
  return interopDefault(import('../pages/_market/_language/user/profile/password.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/password" */
  ));
};

var _003eb0b6 = function _003eb0b6() {
  return interopDefault(import('../pages/_market/_language/user/wishlist.vue'
  /* webpackChunkName: "pages/_market/_language/user/wishlist" */
  ));
};

var _65fd50ba = function _65fd50ba() {
  return interopDefault(import('../pages/_market/_language/help/merchant/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/confirm" */
  ));
};

var _2a058e00 = function _2a058e00() {
  return interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
  ));
};

var _4f22fdcd = function _4f22fdcd() {
  return interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
  ));
};

var _166694ba = function _166694ba() {
  return interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/contact/_form" */
  ));
};

var _5ba4082a = function _5ba4082a() {
  return interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
  /* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
  ));
};

var _e55f1ca4 = function _e55f1ca4() {
  return interopDefault(import('../pages/_market/_language/help/return/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/return/_form" */
  ));
};

var _761b5606 = function _761b5606() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
  ));
};

var _6fa5b2c3 = function _6fa5b2c3() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/index" */
  ));
};

var _baf76d48 = function _baf76d48() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/messages.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/messages" */
  ));
};

var _32eb5912 = function _32eb5912() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/notation.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/notation" */
  ));
};

var _5e686d9d = function _5e686d9d() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/product/_code.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/product/_code" */
  ));
};

var _717063bd = function _717063bd() {
  return interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/_code.vue'
  /* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/_code" */
  ));
};

var _3b948c11 = function _3b948c11() {
  return interopDefault(import('../pages/_market/_language/c/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/c/_alias" */
  ));
};

var _06ed6440 = function _06ed6440() {
  return interopDefault(import('../pages/_market/_language/configurator/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/_model" */
  ));
};

var _2ecc11d8 = function _2ecc11d8() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
  ));
};

var _eef5fc72 = function _eef5fc72() {
  return interopDefault(import('../pages/_market/_language/m/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/m/_alias" */
  ));
};

var _c0cc1c38 = function _c0cc1c38() {
  return interopDefault(import('../pages/_market/_language/p/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/p/_alias" */
  ));
};

var _12b900c8 = function _12b900c8() {
  return interopDefault(import('../pages/_market/_language/q/_keyword.vue'
  /* webpackChunkName: "pages/_market/_language/q/_keyword" */
  ));
};

var _437f24ca = function _437f24ca() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
  ));
};

var _d3e9a946 = function _d3e9a946() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "" */
  ));
};

var _63bd6b49 = function _63bd6b49() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _52a6eaad = function _52a6eaad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "" */
  ));
};

var _4b34c87e = function _4b34c87e() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "" */
  ));
};

var _3cb0debb = function _3cb0debb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _4aca05f8 = function _4aca05f8() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "" */
  ));
}; // TODO: remove in Nuxt 3


var emptyFn = function emptyFn() {};

var originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyFn;
  var onAbort = arguments.length > 2 ? arguments[2] : undefined;
  return originalPush.call(this, location, onComplete, onAbort);
};

Vue.use(Router);
export var routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior: scrollBehavior,
  routes: [{
    path: "/monitoring",
    component: _f0009660,
    name: "monitoring"
  }, {
    path: "/redirect_url",
    component: _09963114,
    name: "redirect_url"
  }, {
    path: "/tools/grid",
    component: _5a792afc,
    name: "tools-grid"
  }, {
    path: "/:market?/:language",
    component: _6ff3ef24,
    name: "market-language"
  }, {
    path: "/:market?/:language?/autolog",
    component: _2bc1b851,
    name: "market-language-autolog"
  }, {
    path: "/:market?/:language?/cart",
    component: _4222e734,
    name: "market-language-cart"
  }, {
    path: "/:market?/:language?/help",
    component: _5762d4d0,
    name: "market-language-help"
  }, {
    path: "/:market?/:language?/login",
    component: _dca4a8f6,
    name: "market-language-login"
  }, {
    path: "/:market?/:language?/lost-password",
    component: _b07d3c80,
    name: "market-language-lost-password"
  }, {
    path: "/:market?/:language?/reset-password",
    component: _1ee5a5ed,
    name: "market-language-reset-password"
  }, {
    path: "/:market?/:language?/signup",
    component: _1f3c9ba8,
    name: "market-language-signup"
  }, {
    path: "/:market?/:language?/sitemap",
    component: _30f6d0d8,
    name: "market-language-sitemap"
  }, {
    path: "/:market?/:language?/store-locator",
    component: _3cdf9d6e,
    name: "market-language-store-locator"
  }, {
    path: "/:market?/:language?/user",
    component: _4baa0da2,
    name: "market-language-user"
  }, {
    path: "/:market?/:language?/help/confirm",
    component: _0330cdf4,
    name: "market-language-help-confirm"
  }, {
    path: "/:market?/:language?/help/deliveryConfirm",
    component: _43d9531c,
    name: "market-language-help-deliveryConfirm"
  }, {
    path: "/:market?/:language?/s/catalogue-luminaires",
    component: _51492e83,
    name: "market-language-s-catalogue-luminaires"
  }, {
    path: "/:market?/:language?/s/home-by-me",
    component: _b647cce0,
    name: "market-language-s-home-by-me"
  }, {
    path: "/:market?/:language?/s/lighting",
    component: _ee1edf88,
    name: "market-language-s-lighting"
  }, {
    path: "/:market?/:language?/s/sustainable-development",
    component: _7a8d8aeb,
    name: "market-language-s-sustainable-development"
  }, {
    path: "/:market?/:language?/t/confirmed",
    component: _1288a9c0,
    name: "market-language-t-confirmed"
  }, {
    path: "/:market?/:language?/t/login",
    component: _8fae02ac,
    name: "market-language-t-login"
  }, {
    path: "/:market?/:language?/t/lost-password",
    component: _7dc48036,
    name: "market-language-t-lost-password"
  }, {
    path: "/:market?/:language?/t/payment",
    component: _32adf6f2,
    name: "market-language-t-payment"
  }, {
    path: "/:market?/:language?/t/payment-paypal-canceled",
    component: _fc692426,
    name: "market-language-t-payment-paypal-canceled"
  }, {
    path: "/:market?/:language?/t/payment-paypal-pending",
    component: _177815f3,
    name: "market-language-t-payment-paypal-pending"
  }, {
    path: "/:market?/:language?/t/refused",
    component: _1830ff5e,
    name: "market-language-t-refused"
  }, {
    path: "/:market?/:language?/t/shipping",
    component: _12125906,
    name: "market-language-t-shipping"
  }, {
    path: "/:market?/:language?/t/signup",
    component: _cd5e78b2,
    name: "market-language-t-signup"
  }, {
    path: "/:market?/:language?/user/gift-card-download",
    component: _157c6728,
    name: "market-language-user-gift-card-download"
  }, {
    path: "/:market?/:language?/user/gift-cards",
    component: _0fb817e6,
    name: "market-language-user-gift-cards"
  }, {
    path: "/:market?/:language?/user/orders",
    component: _41803588,
    name: "market-language-user-orders"
  }, {
    path: "/:market?/:language?/user/profile",
    component: _02d53cf9,
    children: [{
      path: "",
      component: _4cb464bc,
      name: "market-language-user-profile"
    }, {
      path: "addresses",
      component: _4a66568c,
      name: "market-language-user-profile-addresses"
    }, {
      path: "alerts",
      component: _d9238cc6,
      name: "market-language-user-profile-alerts"
    }, {
      path: "password",
      component: _459a6c21,
      name: "market-language-user-profile-password"
    }]
  }, {
    path: "/:market?/:language?/user/wishlist",
    component: _003eb0b6,
    name: "market-language-user-wishlist"
  }, {
    path: "/:market?/:language?/help/merchant/confirm",
    component: _65fd50ba,
    name: "market-language-help-merchant-confirm"
  }, {
    path: "/:market?/:language?/configurator/product/:model?",
    component: _2a058e00,
    name: "market-language-configurator-product-model"
  }, {
    path: "/:market?/:language?/e/magazine/:slug?",
    component: _4f22fdcd,
    name: "market-language-e-magazine-slug"
  }, {
    path: "/:market?/:language?/help/contact/:form?",
    component: _166694ba,
    name: "market-language-help-contact-form"
  }, {
    path: "/:market?/:language?/help/faq/:answer?",
    component: _5ba4082a,
    name: "market-language-help-faq-answer"
  }, {
    path: "/:market?/:language?/help/return/:form?",
    component: _e55f1ca4,
    name: "market-language-help-return-form"
  }, {
    path: "/:market?/:language?/user/orders/:reference",
    component: _761b5606,
    name: "market-language-user-orders-reference"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact",
    component: _6fa5b2c3,
    name: "market-language-help-merchant-order-reference-contact"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/messages",
    component: _baf76d48,
    name: "market-language-help-merchant-order-reference-messages"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/notation",
    component: _32eb5912,
    name: "market-language-help-merchant-order-reference-notation"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact/product/:code?",
    component: _5e686d9d,
    name: "market-language-help-merchant-order-reference-contact-product-code"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact/:code",
    component: _717063bd,
    name: "market-language-help-merchant-order-reference-contact-code"
  }, {
    path: "/:market?/:language?/c/:alias?",
    component: _3b948c11,
    name: "market-language-c-alias"
  }, {
    path: "/:market?/:language?/configurator/:model?",
    component: _06ed6440,
    name: "market-language-configurator-model"
  }, {
    path: "/:market?/:language?/inspirations/:slug?",
    component: _2ecc11d8,
    name: "market-language-inspirations-slug"
  }, {
    path: "/:market?/:language?/m/:alias?",
    component: _eef5fc72,
    name: "market-language-m-alias"
  }, {
    path: "/:market?/:language?/p/:alias?",
    component: _c0cc1c38,
    name: "market-language-p-alias"
  }, {
    path: "/:market?/:language?/q/:keyword?",
    component: _12b900c8,
    name: "market-language-q-keyword"
  }, {
    path: "/:market?/:language?/e/:alias?/:slug?",
    component: _437f24ca,
    name: "market-language-e-alias-slug"
  }, {
    path: "/",
    component: _d3e9a946,
    name: "market-language-home-fr"
  }, {
    path: "/:market/:language/inspirations*",
    component: _63bd6b49,
    name: "market-language-inspirations-fr"
  }, {
    path: "/:market/:language/inspirationen*",
    component: _63bd6b49,
    name: "market-language-inspirations-de"
  }, {
    path: "/:market/:language/ispirazione*",
    component: _63bd6b49,
    name: "market-language-inspirations-it"
  }, {
    path: "/:market/:language/inspiration*",
    component: _63bd6b49,
    name: "market-language-inspirations-en"
  }, {
    path: "/:market/:language/inspiration*",
    component: _63bd6b49,
    name: "market-language-inspirations-pt"
  }, {
    path: "/:market/:language/inspiracion*",
    component: _63bd6b49,
    name: "market-language-inspirations-es"
  }, {
    path: "/:market/:language/s/inspiratie*",
    component: _63bd6b49,
    name: "market-language-inspirations-nl"
  }, {
    path: "/:market/:language/s/luminaires*",
    component: _52a6eaad,
    name: "market-language-lighting-fr"
  }, {
    path: "/:market/:language/s/leuchten*",
    component: _52a6eaad,
    name: "market-language-lighting-de"
  }, {
    path: "/:market/:language/s/illuminazioni*",
    component: _52a6eaad,
    name: "market-language-lighting-it"
  }, {
    path: "/:market/:language/s/lighting*",
    component: _52a6eaad,
    name: "market-language-lighting-en"
  }, {
    path: "/:market/:language/s/lighting*",
    component: _52a6eaad,
    name: "market-language-lighting-pt"
  }, {
    path: "/:market/:language/s/lamparas*",
    component: _52a6eaad,
    name: "market-language-lighting-es"
  }, {
    path: "/:market/:language/s/verlichting*",
    component: _52a6eaad,
    name: "market-language-lighting-nl"
  }, {
    path: "/:market/:language/s/atelier-deco*",
    component: _4b34c87e,
    name: "market-language-home-by-me-fr"
  }, {
    path: "/:market/:language/s/atelier-arredo*",
    component: _4b34c87e,
    name: "market-language-home-by-me-it"
  }, {
    path: "/:market/:language/s/taller-de-decoracion*",
    component: _4b34c87e,
    name: "market-language-home-by-me-es"
  }, {
    path: "/:market/:language/s/dekowerkstatt*",
    component: _4b34c87e,
    name: "market-language-home-by-me-de"
  }, {
    path: "/:market/:language/s/decor-workshop*",
    component: _4b34c87e,
    name: "market-language-home-by-me-en"
  }, {
    path: "/:market/:language/:alias/:slug",
    component: _3cb0debb,
    name: "market-language-editorial"
  }, {
    path: "/:market/:language/magasins/",
    component: _4aca05f8,
    name: "store-locator"
  }],
  fallback: false
};
export function createRouter() {
  var router = new Router(routerOptions);
  var resolve = router.resolve.bind(router); // encodeURI(decodeURI()) ~> support both encoded and non-encoded urls

  router.resolve = function (to, current, append) {
    if (typeof to === 'string') {
      to = encodeURI(decodeURI(to));
    }

    return resolve(to, current, append);
  };

  return router;
}